import React from 'react';
import { FileMagnifyingGlass, GraduationCap, ListNumbers, FileText, Tag } from '@phosphor-icons/react';

export default function ResearchPaperModule({ metadata, onChange }) {
  const handleChange = (field, value) => {
    onChange({ ...metadata, [field]: value });
  };

  return (
    <div className="space-y-6">
      {/* Research Field */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <GraduationCap size={16} />
          Research Field (शोध क्षेत्र) <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          value={metadata.research_field || ''}
          onChange={(e) => handleChange('research_field', e.target.value)}
          placeholder="e.g., Hindi Literature, Linguistics, Cultural Studies"
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors"
        />
      </div>

      {/* Abstract */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <FileText size={16} />
          Abstract (सारांश) <span className="text-red-500">*</span>
        </label>
        <textarea
          value={metadata.abstract || ''}
          onChange={(e) => handleChange('abstract', e.target.value)}
          placeholder="Brief summary of research (150-250 words)..."
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors resize-none"
          rows={5}
        />
        <p className="text-xs text-muted-foreground mt-1">
          Word count: {(metadata.abstract || '').split(/\s+/).filter(w => w).length}
        </p>
      </div>

      {/* Keywords */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <Tag size={16} />
          Keywords (मुख्य शब्द) <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          value={metadata.keywords || ''}
          onChange={(e) => handleChange('keywords', e.target.value)}
          placeholder="e.g., Hindi Poetry, Modernism, Kabir, Bhakti Movement"
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors"
        />
        <p className="text-xs text-muted-foreground mt-1">
          Comma-separated list (5-8 keywords recommended)
        </p>
      </div>

      {/* Methodology */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <FileMagnifyingGlass size={16} />
          Methodology (पद्धति)
        </label>
        <textarea
          value={metadata.methodology || ''}
          onChange={(e) => handleChange('methodology', e.target.value)}
          placeholder="Research methods used (qualitative, quantitative, mixed methods)..."
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors resize-none"
          rows={3}
        />
      </div>

      {/* References Count */}
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium mb-2 flex items-center gap-2">
            <ListNumbers size={16} />
            Number of References
          </label>
          <input
            type="number"
            value={metadata.references_count || ''}
            onChange={(e) => handleChange('references_count', e.target.value)}
            placeholder="e.g., 25"
            min="0"
            className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-2">
            Pages
          </label>
          <input
            type="number"
            value={metadata.page_count || ''}
            onChange={(e) => handleChange('page_count', e.target.value)}
            placeholder="e.g., 15"
            min="1"
            className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors"
          />
        </div>
      </div>

      {/* Co-Authors */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <GraduationCap size={16} />
          Co-Authors (सह-लेखक)
        </label>
        <input
          type="text"
          value={metadata.co_authors || ''}
          onChange={(e) => handleChange('co_authors', e.target.value)}
          placeholder="Names of co-authors (comma-separated)"
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors"
        />
      </div>

      {/* Institution */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <GraduationCap size={16} weight="fill" className="text-blue-500" />
          Institution / University
        </label>
        <input
          type="text"
          value={metadata.institution || ''}
          onChange={(e) => handleChange('institution', e.target.value)}
          placeholder="Your affiliated institution"
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors"
        />
      </div>

      {/* DOI / Identifier */}
      <div>
        <label className="block text-sm font-medium mb-2">
          DOI / Identifier
        </label>
        <input
          type="text"
          value={metadata.doi || ''}
          onChange={(e) => handleChange('doi', e.target.value)}
          placeholder="e.g., 10.1234/example.doi"
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors"
        />
      </div>
    </div>
  );
}
